import React, { useContext } from "react";
import Head from "next/head";
import Header from "@/components/Header/Header";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";
import Features from "@/components/Home/Features";
import LlmSlider from "@/components/Home/LlmSlider.js";
import Welcome from "@/components/Home/Welcome.js";
import Context from "@/context/Context";
import Circle from "@/components/Home/Circle";
import Split from "@/components/Split/Split";
import ChatBot from "@/components/ChatBot/ChatBot";
import Design from "@/components/Design/Design";
import Cookie from "@/components/Cookies/Cookies";
import Pricing from "@/components/Pricing/Pricing";
import Accordion from "@/components/Accordion/Accordion";
import Footer from "@/components/Footer/Footer";
import EvolveLink from "@/components/EvolveLink/EvolveLink";
import DesignHomeMessage from "@/components/DesignHomeMessage/DesignHomeMessage";
import DesignHomeHead from "@/components/DesignHomeHead/DesignHomeHead";
import Home from "@/components/Home/LandingPage";
import PageHead from "../Head";
import { useIntl } from 'react-intl';
import { CookieContext } from "@/context/CookieContext"; // CookieContext ekliyoruz

const HomePage = ({ handleLanguageChange }) => {
  const intl = useIntl();
  const { cookiesAccepted, acceptCookies } = useContext(CookieContext); // Context'ten çerez kabul durumunu alıyoruz

  return (
    <>
   

      <PageHead title={intl.formatMessage({ id: "home" })} />

      <main className="page-wrapper">
        <Context>
          <Home />
        </Context>
      </main>

      <Cookie />
    </>
  );
};

export default HomePage;
